import { useAppGrid } from "../../../apps-integration/hooks/useAppGrid";

export const usePayoutMethods = () => {
  const { getAppsForCategory } = useAppGrid();
  const paymentMethods = getAppsForCategory("payments");

  const getAppForMethod = (methodId) => {
    return paymentMethods.find((app) => app.id === methodId || app.slug === methodId);
  };

  return {
    paymentMethods,
    getAppForMethod,
  };
};
